import { Separator, YStack } from 'tamagui';

interface ReportDetailSectionProps {
  children: React.ReactNode;
}

export const ReportDetailSection = ({
  children,
}: ReportDetailSectionProps): React.ReactElement => {
  return (
    <YStack gap="$true">
      {children}
      <Separator />
    </YStack>
  );
};
